<template>
    <div class="chart-bar">
        <div class="chart-bar-year">
            <div class="chart-bar-year-container">
                <span>{{ year }}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        year: String
    }
};
</script>
